import Work1 from "../../assets/work1.jpg"
import Work2 from "../../assets/work2.jpg"
import Work3 from "../../assets/work3.png"
import Work4 from "../../assets/work4.jpg"
import Work6 from "../../assets/work6.jpg"
import Work7 from "../../assets/leici.png"
import Work8 from "../../assets/sanblasthumbail.png"
import Work9 from "../../assets/work9.png"
import Work10 from "../../assets/work10.png"

export const projectsData = [
    {
        id:1,
        image: Work1,
        title: 'Social Media Post | CircusBar Xela',
        category: 'post design',
        link: 'https://www.behance.net/gallery/152915763/Social-Media-CircusBar-Xela',
    },
    {
        id:1,
        image: Work2,
        title: 'Social Media Post | La Bodeguita',
        category: 'post design',
        link: 'https://www.behance.net/gallery/152971455/Social-Media-La-Bodeguita-Xela',
    },
    {
        id:1,
        image: Work3,
        title: 'Social Media Post | Burguer Shop',
        category: 'post design',
        link : 'https://www.behance.net/gallery/155392177/Social-Media-2022',
    },
    {
        id:1,
        image: Work4,
        title: 'Social Media Post | El Pinche Xela',
        category: 'post design',
        link: 'https://www.behance.net/gallery/152915137/Social-Media-El-Pinche-Xela',
    },
    {
        id:1,
        image: Work6,
        title: 'Branding | Taquísimo',
        category: 'branding',
        link: 'https://www.behance.net/gallery/116716551/Manual-de-Identidad-Taquisimo',
    },
    {
        id:1,
        image: Work7,
        title: 'Branding | LEICI',
        category: 'branding',
        link: 'https://www.behance.net/gallery/160218749/Leici-Branding',
    },
    {
        id:1,
        image: Work8,
        title: 'Branding | SanBlas',
        category: 'branding',
        link: 'https://www.behance.net/gallery/161258477/San-Blas-Branding',
    },
    {
        id:1,
        image: Work9,
        title: 'Appointments Project',
        category: 'web',
        link: 'https://github.com/byteGabo/ClinicaTOS2',
    },
     {
        id:1,
        image: Work10,
        title: 'Hoog Website',
        category: 'web',
        link: 'https://github.com/byteGabo/HoogNewWebsite',
    },
]

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'web',
    },
    {
        name: 'branding',
    },
    {
        name: 'post design',
    },
]
